
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { SavePropertyBrokerInputModel, BrokerSelecttionModel } from '../../shared/models/SavePropertyInputModel';
import { ValidationService } from '../../shared/providers/validation.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { CommonService } from '../../shared/providers/common.service';
import { ToastService } from '../../shared/providers/toast.service';
import { timeoutWith } from 'rxjs/operators';

@Component({
    selector: 'app-broker-details',
    templateUrl: './broker-details.component.html',
    styleUrls: ['./broker-details.component.css']
})
export class BrokerDetailsComponent implements OnInit {

    @Output() save = new EventEmitter();
    @Output() close = new EventEmitter();

    @ViewChild('contactForm') contactForm: NgForm;

    @Input() currentBrokerLicense: SavePropertyBrokerInputModel;
    @Input() modalRef: BsModalRef;
    @Input() stateId: number;
    @Input() stateName: string;
    @Input() isEdit = false;
    brokers: BrokerSelecttionModel[] = [];


    id: number;
    brokerId?: number;
    license?: number;
    contactType?: number;
    filterBrokers = false;

    private _brokerId?: number;
    private _license?: number;
    private _contactType?: number;
    private _licenseName: string;
    private _phoneNumber: string;
    private _email: string;
    private _name: string;
    contactTypeId: number;
    brokerValid: boolean = false;
    licenseValid: boolean = false;
    contactTypeValid: boolean = false;
    Valid: boolean = false;

    contactTypes = [
        { Id: 551, Name: 'Primary' },
        { Id: 552, Name: 'Secondary' },
        { Id: 553, Name: 'Others' }
    ];

    brokerLicenses: SavePropertyBrokerInputModel[] = [];

    constructor(private _propertyManagementService: PropertyManagementService, private _validationService: ValidationService, private _toastService: ToastService, private Common: CommonService) { }

    ngOnInit() {

        //this.bindBrokers();

        this.id = this.currentBrokerLicense.Id;
        if (this.isEdit) {
            this.contactType = this.currentBrokerLicense.ContactTypeId;
            this._contactType = this.contactType;
            this.contactTypeId = this.currentBrokerLicense.ContactTypeId;
            this.brokerId = this.currentBrokerLicense.UserId;
            this.bindBrokers();
            this._propertyManagementService.getBrokerLicenses(this.brokerId).subscribe(response => {
                this.brokerLicenses = response;
            });
            this.license = this.currentBrokerLicense.BrokerRegionalLicenseId;
            this._brokerId = this.brokerId;
            this._license = this.license;
            this._licenseName = this.currentBrokerLicense.License;
            this._phoneNumber = this.currentBrokerLicense.PhoneNumber;
            this._email = this.currentBrokerLicense.Email;
            this._name = this.currentBrokerLicense.Name;
            this.brokerId = this.currentBrokerLicense.UserId;
            
        } else {
            this.brokerId = 0;
            this._brokerId = 0;
            this.license = 0;
            this.contactTypeId = 0;
            this.currentBrokerLicense.ContactTypeId = 0;
        }
    }

    onBrokerChange($event) {
        if (this.brokerId != 0) {
            this.currentBrokerLicense.UserId = this.brokerId;
            this._propertyManagementService.getBrokerLicenses(this.currentBrokerLicense.UserId).subscribe(response => {
                this.brokerLicenses = response;
            });
            this.license = 0;
            this.currentBrokerLicense.BrokerRegionalLicenseId = 0;
            this.brokerValid = false;
        }
        else {
            this.brokerLicenses = null;
        }
    }

    onSave($event) {

        this.onSaveValidation();
        if (this.Valid) {
            this.currentBrokerLicense.ContactTypeId = this.contactTypeId;
            this.save.emit(this.currentBrokerLicense);
        }
        else {
            this._toastService.addToast({
                title: 'Unable to save broker',
                msg: 'Please fill all the required fields',
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'warning'
            });
        }
    }

    onSaveValidation() {
        this.Valid = true;

        if (this._validationService.isInvalidDropDown(this.brokerId)) {
            this.brokerValid = true;
            this.Valid = false;
        }
        else {
            this.brokerValid = false;
        }
        if (this._validationService.isInvalidDropDown(this.license)) {
            this.licenseValid = true;
            this.Valid = false;
        }
        else {
            this.licenseValid = false;
        }
        if (this._validationService.isInvalidDropDown(this.contactTypeId)) {
            this.contactTypeValid = true;
            this.Valid = false;
        }
        else {
            this.contactTypeValid = false;
        }
      
    }

    onLicenceSelected($event) {
        const lic = this.brokerLicenses.find(x => x.BrokerRegionalLicenseId === this.license);
        if (lic) {
            this.currentBrokerLicense.BrokerRegionalLicenseId = this.license;
            this.currentBrokerLicense.License = lic.License;
            this.currentBrokerLicense.PhoneNumber = lic.PhoneNumber;
            this.currentBrokerLicense.Email = lic.Email;
            this.currentBrokerLicense.Name = lic.Name;
            this.licenseValid = false;
        }
     }

    onFilterChange($event) {
        this.bindBrokers();
    }

    bindBrokers() {
        if (this.contactTypeId == 553) {
            this.Common.GetComplianceBroker().subscribe(response => {
                this.brokers = response;
                this.brokerId = this.isEdit ? this.brokerId : 0;
            });
        }
        else {
            this._propertyManagementService.getBrokers(this.filterBrokers ? this.stateId : 0).subscribe(response => {
                this.brokers = response;
                this.brokerId = this.isEdit ? this.brokerId : 0;
            });
        }
        this.brokerLicenses = null;
    }

    onClose($event) {
        this.close.emit();
    }

    //onContactTypeSelected($event) {
    //  //this.currentBrokerLicense.ContactType = this.contactTypes.find(x => x.Id === this.contactType).Name;
    //  //this.currentBrokerLicense.ContactTypeId = this.contactType;
    //}
}
